import { isValidForEnvironment } from 'lib/utils/is-valid-for-environment';
import { Feature } from 'src/.generated/Feature.EnterpriseWeb.model';
import { ComponentProps } from 'lib/types/component-props';
import Head from 'next/head';

export type TtrustArcScriptProps =
  Feature.EnterpriseWeb.RenewalByAndersen.Components.Advanced.TrustArc.TrustArcScript &
    ComponentProps;

const TrustArcHeaderScript = (props: TtrustArcScriptProps): JSX.Element | null => {
  const { fields } = props;

  const sourceUrl = fields?.src?.value || '';
  const tag = fields?.tag?.value || '';

  if (!isValidForEnvironment(props) || !sourceUrl) {
    return null;
  }
  return (
    <>
      <Head>
        <div id="teconsent">
          <script type="text/javascript" async src={sourceUrl}></script>
        </div>
      </Head>
      <span dangerouslySetInnerHTML={{ __html: tag }} />
    </>
  );
};

export default TrustArcHeaderScript;
